import { IApplicationState } from "src/~store/models/ApplicationState";
import { createSelector } from "reselect";
import { SettingType } from "./models/setting";
import { ISLColorSecondsSettings } from "src/app/chats/~store/models/SLColorSecondsSettings";
import { MAX_PAUSE_CATEGORIES } from "src/app/chats-panel/~store/actions/ChatConstants";
import { IMapSettings } from "src/app/chats/~store/models/MapSettings";
import { MapProvider } from "src/app/chats/~store/models/enums/MapProvider";
import { DeletedMessageDisplay } from "../../chat/models/enums/DeletedMessageDisplay";
import { IDeletedMessageSettings } from "../../chat/models/DeletedMessageSettings";

const settingSelector = (state: IApplicationState) => state.settingState;

const settingListSelector = createSelector(
  settingSelector,
  (settingState) => settingState.settingList
);

export const settingsSelector = createSelector(
  settingListSelector,
  (settingList) =>
    settingList.settings
      .filter(
        (s) =>
          s.id
            .toLocaleLowerCase()
            .includes(settingList.searchString.toLocaleLowerCase()) &&
          s.settingTypeModel !== SettingType.User &&
          (settingList.searchType
            ? settingList.searchType === s.settingTypeModel
            : true)
      )
      .sort((a, b) => {
        return a.isCreating ? -1 : a.id.localeCompare(b.id);
      })
);

export const globalSettingsSelector = createSelector(
  settingSelector,
  (settingState) => settingState.globalSettings
);

export const sLColorSecondsSettingsSelector = createSelector(
  globalSettingsSelector,
  (settings) =>
    ({
      sLNoColorSeconds: Number(settings.chatOptions.slNoColorSeconds),
      sLRedSeconds: Number(settings.chatOptions.slRedSeconds),
      sLYellowSeconds: Number(settings.chatOptions.slYellowSeconds),
    } as ISLColorSecondsSettings)
);

export const mapSettingsSelector = createSelector(
  globalSettingsSelector,
  (settings) =>
    ({
      mapProvider: settings.chatOptions.mapProvider,
    } as IMapSettings)
);

export const operatorDisconnectionTimeoutSelector = createSelector(
  globalSettingsSelector,
  (settings) => Number(settings.operatorOptions.disconnectionTimeout)
);

export const closeChatCategoriesSelector = createSelector(
  globalSettingsSelector,
  (settings) =>
    settings.chatOptions.closeChatCategories
      .split(",")
      .slice()
      .map((category) => category.trim())
      .filter((category) => category !== "")
);

export const pauseCategoriesSelector = createSelector(
  globalSettingsSelector,
  (settings) =>
    settings.operatorOptions.pauseCategories
      .split(",")
      .slice(0, MAX_PAUSE_CATEGORIES)
      .map((category) => category.trim())
      .filter((category) => category !== "")
);

export const showHintsFromAllOperatorsSelector = createSelector(
  globalSettingsSelector,
  (settings) => settings.operatorOptions.showHintsFromAllOperators
);

export const localeSelector = createSelector(
    globalSettingsSelector,
    (settings) => settings.commonOptions.locale
)

export const deletedMessageSettingsSelector = createSelector(
    globalSettingsSelector,
    (settings) =>
    ({deletedMessageDisplay:
            settings.chatOptions?.deletedMessageDisplay === DeletedMessageDisplay.Default ||
                settings.chatOptions?.deletedMessageDisplay === DeletedMessageDisplay.ShowAsNormal ||
                settings.chatOptions?.deletedMessageDisplay === DeletedMessageDisplay.Hide
                ? settings.chatOptions.deletedMessageDisplay
                : DeletedMessageDisplay.Default,
    } as IDeletedMessageSettings)
);